import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../core/services';

@Pipe({
  name: 'translate',
  pure: false,
  standalone: true,
})
export class TranslatePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(key: string): string | void {
    return this.translateService.getTranslation(key);
  }
}
